class WishlistListPermissions extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document.body,
      'wishlist-list-permissions:check',
      this.handleCheck.bind(this),
    )
  }

  async handleCheck (event) {}
}

if (!window.customElements.get('wishlist-list-permissions')) {
  window.customElements.define(
    'wishlist-list-permissions',
    WishlistListPermissions,
  )
}
